import { ChevronLeft, ChevronRight } from 'lucide-react'
import type { Pagination as PaginationType } from '@/types'

interface PaginationProps {
  pagination: PaginationType
  onPageChange: (page: number) => void
  itemLabel?: string
}

export function Pagination({ pagination, onPageChange, itemLabel = 'publication' }: PaginationProps) {
  const { current_page, total_pages, total_count } = pagination

  if (total_pages <= 1) {
    return null
  }

  // Calcule les pages à afficher (max 5)
  const getPageNumbers = () => {
    const pages: number[] = []
    const maxVisible = 5

    if (total_pages <= maxVisible) {
      for (let i = 1; i <= total_pages; i++) {
        pages.push(i)
      }
    } else if (current_page <= 3) {
      for (let i = 1; i <= maxVisible; i++) {
        pages.push(i)
      }
    } else if (current_page >= total_pages - 2) {
      for (let i = total_pages - maxVisible + 1; i <= total_pages; i++) {
        pages.push(i)
      }
    } else {
      for (let i = current_page - 2; i <= current_page + 2; i++) {
        pages.push(i)
      }
    }

    return pages
  }

  return (
    <div className="flex flex-col sm:flex-row items-center justify-between gap-4 mt-8">
      <p className="text-sm text-gray-500">
        {total_count} {itemLabel}{total_count > 1 ? 's' : ''} - Page {current_page} sur {total_pages}
      </p>

      <div className="flex items-center gap-2">
        <button
          onClick={() => onPageChange(current_page - 1)}
          disabled={current_page === 1}
          className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <ChevronLeft className="w-4 h-4" />
          <span className="hidden sm:inline">Precedent</span>
        </button>

        <div className="flex items-center gap-1">
          {getPageNumbers().map((pageNum) => (
            <button
              key={pageNum}
              onClick={() => onPageChange(pageNum)}
              className={`w-10 h-10 rounded-lg text-sm font-medium transition-colors ${
                current_page === pageNum
                  ? 'bg-tessan-primary text-white'
                  : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50'
              }`}
            >
              {pageNum}
            </button>
          ))}
        </div>

        <button
          onClick={() => onPageChange(current_page + 1)}
          disabled={current_page === total_pages}
          className="flex items-center gap-1 px-3 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          <span className="hidden sm:inline">Suivant</span>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}
